import api from '../../../services/Api';
import { IAuditoriaMutacaoVolatilResultado } from '../interfaces/IAuditoriaMutacaoVolatil';

interface BuscarParams {
  empresaId: number;
  periodo?: string;
}

const resultadoVazio: IAuditoriaMutacaoVolatilResultado = {
  exposicaoTotalGeral: 0,
  passivoTributarioTotal: 0,
  multaQualificadaTotal: 0,
  jurosSelicTotal: 0,
  totalErros: 0,
  totalAlertas: 0,
  totalAvisos: 0,
  status: 'CONCILIADO',
  mensagemDirecionamento: '',
  fundamentacaoLegal: '',
  itens: [],
};

export const AuditoriaMutacaoVolatilService = {
  async buscarResultado(params: BuscarParams): Promise<IAuditoriaMutacaoVolatilResultado> {
    const response = await api.get<IAuditoriaMutacaoVolatilResultado>(
      'auditoria-mutacao-volatil/resultado',
      { params: { empresaIds: params.empresaId, periodo: params.periodo || '' } }
    );
    return response.data || resultadoVazio;
  },
};
